import React from 'react'
import axios from 'axios'
import { inject, observer } from 'src/core/store'
import './index.less'
import { getlang, setlang } from 'src/helper/getlang'
import { setUidToken } from 'src/helper/tool'
import langM from './lang'
import Toast from 'src/component/Toast'
import { apiLadiesRegister } from 'src/helper/ladies'
import http from 'src/helper/http'
import { history } from 'src/core/router'

@inject('store')
@observer
export default class WeekStar extends React.Component {
  constructor(props) {
    super(props)
    // this.ladiesStore = this.props.store.register('activity/ladies')
  }
  state = {
    lang: langM.en,
    language: "en",
    ruleStatus: false,
    ruleStatus1: false,
    ruleStatus2: false,
    recordStatus: false,
    time: 0,
    toastContent: '',
    userinfo: {},
    introduction: "",
    imgUrl: "",
    imagePath: "",
    imageBase: "any",
    toastContent: '',
    res: {},
  }
  async componentWillMount() {
    let { language } = this.props.location.query
    language =await getlang(language)
    console.log("language", language)
    this.setState({
      lang: setlang(language, langM),
      language: language,
    })
    let uid = await setUidToken(this.props.location.query)
    await this.RunOnStart(uid)
  }

  async RunOnStart(uid) {
    let d = await http.post('/web/MyAccountInfo')
    this.setState({ userinfo: d.res })
  }


  async changeValue(e, name) {
    console.log(e.target.value, name)
    this.setState({ introduction: e.target.value })
  }


  async onImgFileFn(e) {
    e.preventDefault()
    //获取图片文件，图片类型，图片大小
    const file = e.target.files[0]
    const type = file.type
    const size = file.size
    const regularType = ['image/png', 'image/jpg', 'image/jpeg']
    //图片类型限制
    if (regularType.indexOf(type.toLowerCase()) === -1) {
      Toast.fail('Only supports PNG images!')
      return false
    }
    //图片大小限制
    if (size && size > 5242880) {
      // 5 * 1024 * 1024，size的单位是字节
      Toast.fail('The image size should less than 5M!')
      return false
    }
    //图片文件转成base64格式
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onloadend = () => {
      this.setState({ imagePath: reader.result })
    }
    const config = {
      headers: {
        // 'X-Uid': this.state.userinfo.uid,
      }
    }
    const formData = new FormData();
    formData.append('file', e.target.files[0]);
    axios.post("/web/upload", formData, config)
      .then(res => {
        this.setState({ imgUrl: res.res })
      })
  }

  hideRule = async (status) => {
    this.setState({
      ruleStatus: status
    })
  }

  hideRule1 = async (status) => {
    this.setState({
      ruleStatus1: status
    })
    if (status == false) {
      history.push(`/activity/ladies`)
    }
  }

  hideRule2 = async (status) => {
    this.setState({
      ruleStatus2: status
    })
  }

  apply = async (id) => {
    // if (this.state.imgUrl==""){
    //   // this.state.imgUrl = "https://img.chatie.live/app/blank.png"
    // }
    if (this.state.introduction == "") {
      this.hideRule2(true)
      return
    }
    this.setState({ res: await apiLadiesRegister(this.state.imgUrl, this.state.introduction) })
    let res = this.state.res
    if (res.code > 0) {
      this.setState({
        toastContent: res.msg
      })
      this.refs.toast.hideRule(true)
      this.hideRule1(false)
    } else {
      this.hideRule1(true)

    }
  }

  del(nu) {
    this.setState({ imgUrl: "" })
    this.setState({ imagePath: "" })
  }

  render() {
    let { language, lang } = this.state
    return (
      <div className={`ladies-register ${language == 'ar' && 'arlang'}`}>
        <div className='rules'>
          <span>{this.state.lang.ruleText}</span>
          <div className={`content ${language == 'ar' && 'arlang'}`} dangerouslySetInnerHTML={{ __html: lang.rule }}></div>
        </div>

        <div className='form-box'>
          <div className='input-box'>
            <span><b>* </b> User ID</span>
            <input type="text" name='uid' value={this.state.userinfo.duid} readonly='readonly' />
          </div>
          <div className='input-box'>
            <span><b>* </b> User Level</span>
            <input className='level' type="text" name='level' value={`W: ${this.state.userinfo.wealthLv} C: ${this.state.userinfo.charmLv} A: ${this.state.userinfo.activLv} `} readonly='readonly' />
          </div>

          <div className='text-input'>
            <span>*</span><textarea placeholder='For us to know better about you. Please introduce yourself.300 words Max' onChange={(event, name) => this.changeValue(event, "des")}></textarea>
          </div>
          <div className='input-box input-image'>
            <span> Proof of Comment</span>
          </div>
          <label className='select-img-input' htmlFor="upload"></label>
          <input
            id='upload'
            className='upload'
            onChange={(event) => this.onImgFileFn(event)}
            type='file'
            name='fileSelect'
            accept='image/*'
            multiple="multiple"
          />

          <div className='apply' onClick={this.apply.bind(this, 1)} >apply</div>

          <div className='display-img'>
            {this.state.imgUrl != "" && <img className='del' onClick={this.del.bind(this, 1)} src="/img/activity/ladies/del.png" />}
            {this.state.imgUrl != "" && <img className='imagePath' src={this.state.imgUrl} />}
          </div>
        </div>

        <Toast language={language} lang={this.state.lang} ref="toast" id="toast" toastContent={this.state.toastContent} />

        {/* 规则页面 */}
        {/* <div className="rules" onClick={this.hideRule1.bind(this, true)}>
            {this.state.lang.ruleText}
          </div> */}

        {this.state.ruleStatus1 && <div className="loading" onClick={this.hideRule1.bind(this, false)}></div>}
        {this.state.ruleStatus1 && (
          <div className={`popRule animationBeBigCenter`} >
            <div>Submission completed<br />One of our team will contact you shortly.</div>
            <span onClick={this.hideRule1.bind(this, false)}>OK</span>
          </div>
        )}


        {this.state.ruleStatus2 && <div className="loading" onClick={this.hideRule2.bind(this, false)}></div>}
        {this.state.ruleStatus2 && (
          <div className={`popRule animationBeBigCenter`} >
            <div>You have missed a step.<br />Please fill the from</div>
            <span onClick={this.hideRule2.bind(this, false)}>OK</span>
          </div>
        )}


      </div>
    )
  }

}


// WEBPACK FOOTER //
// src/pages/activity/ladiesregister2/index.js